import { getConfig } from './config'

export const b64DecodeUnicode = str =>
  decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function(c) {
        return `%` + (`00` + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(``)
  )

/** Curly apostrophes from admin paste or iOS become the straight keyboard apostrophe. */
const straightenApostrophes = value => String(value || ``).replace(/[\u2018\u2019]/g, `'`)

/** Trim, lowercase, and straighten apostrophes so a typed answer can match a pasted one. */
export const normalizeAnswer = value => straightenApostrophes(value).trim().toLowerCase()

/** Split multi-answer fields on semicolons only (commas are allowed inside answers). */
export const splitAcceptedAnswers = answers =>
  String(answers || ``)
    .split(`;`)
    .map(answer => answer.trim())
    .filter(Boolean)

/** Accepted answers normalized for case-insensitive matching. */
export const parseAcceptedAnswers = answers => splitAcceptedAnswers(answers).map(normalizeAnswer)

const getMediaBase = () => {
  const explicit = getConfig(`MEDIA_URL_DOMAIN`)
  if (explicit) {
    return explicit
  }
  const apiUrl = getConfig(`API_URL`)
  if (apiUrl) {
    return apiUrl.replace(/\/api\/v2\/?$/, '')
  }
  return false
}

export const getStaticUrl = url => {
  // Bundled UI sounds live in the play app (Vite publicDir). Keep them same-origin.
  // Sending them through the API host makes LiteSpeed gzip mp3 as `audio/mpeg`, which
  // Chrome's Audio element won't decode (network 206, but silent playback).
  if (typeof url === `string` && url.startsWith(`/sounds/`)) {
    return url
  }

  const staticBase =
    getConfig(`STATIC_URL_DOMAIN`) ||
    (getMediaBase() ? `${getMediaBase()}/static/` : false)
  if (staticBase) {
    // Avoid `.../static/` + `/path` → `.../static//path` (404 on Django).
    const base = staticBase.replace(/\/?$/, `/`)
    const path = String(url || ``).replace(/^\//, ``)
    return base + path
  }
  return url
}

export const getMediaUrl = url => {
  if (!url) {
    return url
  }
  const mediaBase = getMediaBase()

  // API responses often include absolute localhost URLs; rewrite when using a tunnel.
  if (mediaBase && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//.test(url)) {
    const path = url.replace(/^https?:\/\/[^/]+/, '')
    return mediaBase + path
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  if (mediaBase) {
    if (url.startsWith('/')) {
      return mediaBase + url
    }
    return `${mediaBase}/${url}`
  }
  return url
}

export const getAdminUrl = (path = ``) => {
  const explicit = getConfig(`ADMIN_DOMAIN`)
  let base
  if (explicit) {
    base = /^https?:\/\//.test(explicit) ? explicit : `https://${explicit}`
  } else {
    // Fall back to the API host (admin lives on the same domain as the backend).
    base = getMediaBase() || ``
  }
  base = base.replace(/\/$/, ``)
  if (!base) {
    return path
  }
  return `${base}${path.startsWith(`/`) ? `` : `/`}${path}`
}

export const getHighlightedIndexes = space_string => {
  let indexes = []
  var cur_idx = 0
  for (var i = 0; i < space_string.length; i++) {
    if (space_string[i] == `[`) {
      indexes.push(cur_idx)
    } else if (space_string[i] == `_`) {
      cur_idx += 1
    }
  }

  return indexes
}
